"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("./common");
var IEPolyfill_1 = require("./IEPolyfill");
var IdentityService = /** @class */ (function () {
    function IdentityService() {
        var _this = this;
        this.popup = null;
        this.startIdentityAuth = function (option) {
            var serviceType = option.serviceType;
            var environment = option.environment;
            var serviceUrl = common_1.identityServiceUrl(environment, serviceType);
            var callbackUrl = option.callbackUrl;
            if (option.isPopup === true) {
                _this.popup = common_1.isIE()
                    ? IEPolyfill_1.openPopupWithSameDomain(serviceType, environment, option.url)
                    : _this.openPopup(serviceUrl);
                _this.registerPostMessageEvent(option.successCallback, option.failCallback);
            }
            else {
                window.location.href = serviceUrl + "&callbackUrl=" + encodeURIComponent(callbackUrl);
            }
        };
        // TODO : deprecate
        this.identityServiceStart = function (serviceType, successCallback, failCallback, option) {
            if (option === void 0) { option = {
                environment: 'prod',
                url: '',
            }; }
            var serviceUrl = common_1.identityServiceUrl(option.environment, serviceType);
            _this.popup = common_1.isIE()
                ? IEPolyfill_1.openPopupWithSameDomain(serviceType, option.environment, option.url)
                : _this.openPopup(serviceUrl);
            _this.registerPostMessageEvent(successCallback, failCallback);
        };
        this.openPopup = function (serviceUrl) {
            return window.open(serviceUrl, 'identityServicePopup', 'width=445, height=610, resizable=1, left=0, top=0');
        };
        this.registerPostMessageEvent = function (successCallback, failCallback) {
            var handlePopupMessage = function (event) {
                try {
                    if (typeof event.data.identityToken === 'undefined') {
                        return;
                    }
                    _this.closeIdentity();
                    window.removeEventListener('message', handlePopupMessage);
                    if (event.data.identityToken.length > 0) {
                        successCallback(event.data);
                    }
                    else {
                        failCallback('unauthorized');
                    }
                }
                catch (error) {
                    /* eslint-disable no-console */
                    console.error(error);
                    _this.closeIdentity();
                    failCallback(error);
                }
            };
            window.addEventListener('message', handlePopupMessage);
        };
        this.closeIdentity = function () {
            if (_this.popup) {
                _this.popup.close();
                _this.popup = null;
            }
        };
    }
    return IdentityService;
}());
var identityService = new IdentityService();
exports.identityServiceStart = identityService.identityServiceStart;
exports.startIdentityAuth = identityService.startIdentityAuth;
//# sourceMappingURL=IdentityServiceStart.js.map